import { carouselData } from '@/mocks/home';

const catColors: Record<string, string> = {
  '专题策划': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '怀旧专题': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  '深度专题': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30',
  '入门指南': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '片单推荐': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
};

export default function SectionCarousel() {
  return (
    <section
      id="carousel"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-accent-400 bg-accent-500/10 px-3 py-1 rounded-full mb-3">
            深度内容
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            精选专题
          </h2>
          <p className="text-sm text-foreground-400 mt-2">编辑精心策划的深度影视专题</p>
        </div>

        <div className="flex flex-col gap-4 md:gap-5">
          {carouselData.map((item) => {
            const catClass = catColors[item.category] || 'bg-background-300/50 text-foreground-300 border-background-400/30';

            return (
              <div
                key={item.title}
                className="group flex flex-col md:flex-row bg-background-100 rounded-xl overflow-hidden border border-background-300/40 hover:border-background-400/60 transition-all duration-300 cursor-pointer"
              >
                {/* Image */}
                <div className="md:w-[320px] lg:w-[400px] shrink-0 aspect-[2/1] md:aspect-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Content */}
                <div className="flex-1 p-5 md:p-6 lg:p-8 flex flex-col justify-center">
                  <span className={`inline-block w-fit text-[10px] font-medium px-2 py-0.5 rounded border mb-3 ${catClass}`}>
                    {item.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl lg:text-2xl font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-400 mt-3 leading-relaxed">
                    {item.description}
                  </p>
                  <div className="mt-4 inline-flex items-center gap-1 text-sm text-primary-400">
                    <span>查看专题</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}